import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import EmployeeProfilePage from './pages/EmployeeProfilePage';
import NotFoundPage from './pages/NotFoundPage';
import LoginPage from './pages/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import EditProfilePage from './pages/EditProfilePage';
import SetupPage from './pages/SetupPage';
import AdminPage from './pages/AdminPage';
import InsightsPage from './pages/InsightsPage';
import TeamPage from './pages/TeamPage';
import PetsPage from './pages/PetsPage';
import MeetColleaguePage from './pages/MeetColleaguePage';
import { useAuth } from './contexts/AuthContext';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/setup" element={<SetupPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="employee/:id" element={<EmployeeProfilePage />} />
        <Route path="team/:id" element={<TeamPage />} />
        <Route path="profile/edit" element={<EditProfilePage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="insights" element={<InsightsPage />} />
        <Route path="pets" element={<PetsPage />} />
        <Route path="meet" element={<MeetColleaguePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
